import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	faInfoCircle,
	faTriangleExclamation,
	faAngleRight,
	faAngleLeft,
	faBars,
	faBarcode,
	faCamera,
	faRotate,
	faSortDown,
	faSortUp,
	faTrash,
	faSquareCheck,
	faSquareXmark,
	faArrowDown,
	faSquare,
	faPrint
} from '@fortawesome/free-solid-svg-icons';

import {
	faSquare as faSquareOutline,
	faClock
} from '@fortawesome/free-regular-svg-icons';

const IconMap = {
	barcode: faBarcode,
	camera: faCamera,
	warning: faTriangleExclamation,
	trash: faTrash,
	burger: faBars,
	sortDown: faSortDown,
	sortUp: faSortUp,
	arrowDown: faArrowDown,
	arrowRight: faAngleRight,
	arrowLeft: faAngleLeft,
	spinner: faRotate,
	squareCheck: faSquareCheck,
	squareX: faSquareXmark,
	box: faSquareOutline,
	clock: faClock,
	square: faSquare,
	info: faInfoCircle,
	print: faPrint
};

export type IconGlyph = keyof typeof IconMap;

type IconProps = Omit<FontAwesomeIconProps, "icon"> & {
	glyph: keyof typeof IconMap;
}

export default function Icon({
	glyph,
	...rest
}: IconProps ) {
	const icon = IconMap[ glyph ];

	return <FontAwesomeIcon icon={ icon } { ...rest } />;
}
